import PropTypes from 'prop-types';
import { Search, Users, UsersRound, Mail } from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './QuickAction.module.css';

const iconMap = {
  search: Search,
  users: Users,
  'users-round': UsersRound,
  mail: Mail,
};

/**
 * QuickAction - Horizontal scroll action button for quick social actions
 * 
 * @param {string} icon - Icon name from the iconMap
 * @param {string} label - Button label text
 * @param {function} onClick - Click handler
 * @param {number} badgeCount - Optional badge count to display
 * @param {boolean} isActive - Whether the action is in active state
 */
export function QuickAction({ icon, label, onClick, badgeCount = 0, isActive = false }) {
  const IconComponent = iconMap[icon] || Search;

  return (
    <button 
      className={`${styles.button} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.iconWrapper}>
        <IconComponent size={18} strokeWidth={2} />
        {badgeCount > 0 && (
          <span className={styles.badge}>
            {badgeCount > 99 ? '99+' : badgeCount}
          </span>
        )}
      </div>
      <Text size="xs" color={isActive ? 'cyan' : 'secondary'} weight="medium">
        {label}
      </Text>
    </button>
  );
}

QuickAction.propTypes = {
  icon: PropTypes.oneOf(['search', 'users', 'users-round', 'mail']).isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  badgeCount: PropTypes.number,
  isActive: PropTypes.bool,
};

export default QuickAction;
